import { jsx as _jsx } from "react/jsx-runtime";
import { FlexSpan, Tooltip } from "../../ui";
import { InfoIconContainer } from "./styled";
export const InfoIcon = ({ iconProps, containerStyle, noMargin, ...rest }) => (_jsx(FlexSpan, { display: "inline-flex", ml: noMargin ? undefined : "0.5rem", style: containerStyle, children: _jsx(Tooltip, { ...rest, children: _jsx(InfoIconContainer, { ...iconProps }) }) }));
